import { environment } from '../../../environments/environment';

/**
 * PS-6495 — is this a TEST deployment?
 *
 * Read from `URL_SUB_DOMAIN`, which the deploy job injects per environment ('connect.test.' on
 * test, 'connect.' on live), and deliberately NOT from `environment.production`: that only says how
 * the bundle was built, and a dev-type build is deployed to live routinely. One function so the
 * mock harness and the log label cannot drift apart on what "test" means.
 */
export function isTestDeployment(): boolean {
	return environment.URL_SUB_DOMAIN.includes('test');
}
